/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export default function MainLogo(props) {
	const group = useRef();
	const { nodes, materials } = useGLTF("models/Logos/MainLogo.glb");
	return (
		<group ref={group} {...props} dispose={null}>
			<mesh
				geometry={nodes.Logo_BehindTheFashion.geometry}
				material={materials["Material.001"]}
				position={[-0.38, 2.78, -0.01]}
				rotation={[1.5, 0, 0]}
				scale={[62.91, 62.91, 62.91]}
			/>
		</group>
	);
}

useGLTF.preload("models/Logos/MainLogo.glb");
